import { type ComponentProps } from "react";
import { dropdownPanelListRowVariants } from "@/components/molecules/dropdownPanel/dropdownPanel";
import { cn } from "@/lib/utils";

type DropdownPanelListRowProps = ComponentProps<"li"> & {
  isSelected?: boolean;
  isHighlighted?: boolean;
};

export const DropdownPanelListRow = ({
  className,
  isSelected = false,
  isHighlighted = false,
  ref,
  ...props
}: DropdownPanelListRowProps) => (
  <li
    ref={ref}
    data-dropdown-row
    data-selected={isSelected ? "true" : undefined}
    data-highlighted={isHighlighted ? "true" : undefined}
    className={cn(
      dropdownPanelListRowVariants({
        selected: isSelected,
        highlighted: isHighlighted,
      }),
      className,
    )}
    {...props}
  />
);
